<template>
    <div>
        <el-row class="marB10">
            <el-col :span="9"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}" class="bor">
                <div class="flex mrl2 mrt5">
                    <el-input  v-model="vc_search" placeholder="请按产品搜索" clearable size="mini"></el-input>
                    <el-button class="mrl15 " icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
                </div>
                <el-tree
                        ref="tree"
                        :data="treeData"
                        lazy
                        :load="loadNode"
                        :props="defaultProps"
                        node-key="i_obj"
                        class="trees  video-tree height100"
                        accordion
                        show-checkbox
                        @check-change="handleCheckChange"
                        @check="checktree"
                        :check-strictly="true"
                        :highlight-current='true'
                        :expand-on-click-node="false">
                    <!--      -->
                    <!---->
                </el-tree>
            </el-col>
            <el-col :span="4"  style="height: 100%;">
                <div :style="{lineHeight:tableHeight+'px',textAlign:'center'}">
                    <el-button class="bcBtn" @click="addChoose" :class="baseerp+'btn'" size="mini" >添加</el-button>
                    <el-button class="bcBtn" @click="deleteChoose" :class="baseerp+'btn'" size="mini">删除</el-button>
                </div>
            </el-col>
            <el-col :span="11" class="bor"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <div class="con flex alc" >
                    <el-checkbox-group v-model="rightChoose" @change="handleRightChange">
                        <!--v-if="item.flag==0||item.flag==1"-->
                        <el-checkbox v-for="item in rightData"  :label="item" :key="item.i_obj" style="padding: 5px 0;display: block">
                            {{item.label}}
                            <el-radio-group disabled class="marl5" v-model="item.i_type" @input="changetype">
                                <el-radio  :label='0'>全部</el-radio>
                                <el-radio  :label='1'>散水</el-radio>
                                <el-radio  :label='2'>非散水</el-radio>
                            </el-radio-group>
                        </el-checkbox>
                    </el-checkbox-group>

                </div>
            </el-col>
        </el-row>
        <div class="pz" style="text-align: center">
            <el-button class="bcBtn" @click="saveBtn" :class="baseerp+'btn'" size="mini" >
                保存
            </el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    // import * as API from "./api"
    import * as API from "./../api"
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "TransferTree",
        props:{
            datatype:{
                type: Number,
                required:false,
            },
            pid:{
                type: Number,
                required:true,
            },
            treeChoooseData:{
                type: Array,
                required:true,
            },
            data:{
                type: Object,
                required:true,
            },
        },
        components: {},
        data() {
            return {
                dellist:[],
                baseerp:'',
                allList:[],
                tableHeight:0,
                vc_search:'',
                //choosesearch:'',
                leftChoose:[],
                rightChoose:[],
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_obj'
                },
                rightCheck:false,
                treeData:[],
                tableRightKey:0,
                rightData:[],
                pztype:[
                    {vc_name:"全部",i_type:0},
                    {vc_name:"散水",i_type:1},
                    {vc_name:"非散水",i_type:2}
                ]
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            treeChoooseData:{
                handler() {
                    this.rightData=JSON.parse(JSON.stringify(this.treeChoooseData))
                    this.rightData.map(o=>{
                        o.i_obj=o.vc_obj?o.vc_obj:o.i_obj
                    })
                },
                immediate: true,
                deep:true,
            },


        },
        activated(){
            this.onResize();
        },
        mounted() {
            //console.log("pid",this.pid);
            this.i_type=this.data.i_type;
            this.pDetailList();
            this.baseerp=baseerp;
            // this.tableData=this.transferData.list
            // this.pageTotal=this.total
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-180

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },

            Search(){
                //console.log(this.vc_search,'search')
                if(this.vc_search){

                    let val={
                        i_obj:0,
                        i_level:1,
                        i_state:0,

                    };
                    this.selectDictPz(val);
                }else{
                    this.treeData=[];
                    let val={
                        i_obj:0,
                        i_level:1,
                        i_state:0,

                    };
                    this.getProductTree_z(val);
                }
            },

            addChoose(){
                //console.log(this.leftChoose,'this.leftChoose')
                if (this.leftChoose.length!=0){
                    if (this.datatype==15){
                        //单选
                        for (let r=0;r<this.rightData.length;r++){
                            let d=this.rightData[r]
                            if(d.i_id!==undefined){
                                d.flag=-1
                                d.del=false
                            }else{
                                d.del=true
                            }
                        }
                        this.rightData=this.rightData.filter(i=>i.del==false)
                    }
                    this.leftChoose.forEach(val=>{
                        let at=this.rightData.findIndex(item=>item.i_obj==val.i_obj&&item.flag!=-1);
                        if (at==-1){
                            let obj=val
                            obj.flag=0
                            obj.i_pid=this.pid
                            obj.i_obj=val.i_obj
                            ///obj.i_type=this.datatype
                            obj.i_type=this.i_type
                            this.rightData.unshift(obj)
                        }
                    })
                    this.$refs.tree.setCheckedNodes([]);
                    this.$nextTick(()=>{
                        this.leftChoose=[]
                    })

                    // this.rightChoose=[]

                }

            },
            deleteChoose(){
                //console.log("this.rightData",this.rightData)
                //console.log("this.rightChoose",this.rightChoose)
                let del=[];
                this.rightChoose.map(item=>{
                    if(item.i_id){
                        del.push(item.i_id)
                    }
                });
                //console.log(del,"del");
                this.dellist=del;
                if(del.length!=0){
                    del.map((item)=>{
                        //console.log(item)
                        let idx = this.rightData.findIndex((aitem)=>{
                            return aitem.i_id == item
                        })
                        //console.log(idx)
                        if(idx!=-1){
                            this.rightData.splice(idx,1)
                        }
                    });
                }

                if (this.rightChoose.length>=1) {
                    this.rightData.map((val,index)=> {
                        let at=this.rightChoose.findIndex(item=>item.i_obj==val.i_obj);
                        if (at!==-1) {
                            val.flag = -1
                        }
                    });
                    this.rightData=this.rightData.filter(val =>!(val.flag==-1&&val.i_id==undefined));
                    this.rightChoose=[]
                }
            },

            //根据id查询已有产品
            async pDetailList(){
                let param = {
                    i_mid: this.mid,
                    i_pid:this.pid
                };
                let res = await API.pDetailList(param);
                if (res.code == 1) {
                    res.data.map(item=>{
                        //item.label=item.vc_pzname;
                        item.label=item.vc_pzname+' '+item.i_id;
                    })
                    this.rightData=res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            saveBtn(){
                //this.$emit('choosetree',this.rightData,this.datatype)
                //console.log('this.rightData',this.rightData)
                //console.log('this.rightChoose',this.rightChoose)
                let chooAdd=[];
                this.rightData.map(item=>{
                    if(!item.i_id){
                        chooAdd.push(item)
                    }
                })
                //console.log("chooAdd",chooAdd)
                //return;
                this.savePDetail(chooAdd);

            },
            //保存产品列表
            async savePDetail(chooAdd,del){
                let param = {
                    i_mid: this.mid,
                    i_pid:this.pid,
                    addlist: chooAdd,
                    dellist: this.dellist,
                };
                //console.log(param);
                let res = await API.savePDetail(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.$emit('close')
                    this.$emit('getList')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            cancel(){
                this.$emit('close')
            },
            handleRightChange(val){
                // console.log(val)
                // if (val.rightCheck){
                //     // let obj=val;
                //     // obj.flag=-1
                //     // obj.i_pid=this.pid
                //     // obj.i_obj=obj.i_obj
                //     // obj.i_type=this.datatype
                //     // obj.rightCheck=true
                //     this.rightChoose.push(val)
                // }else{
                //     let i=this.rightChoose.findIndex(item=>item.i_obj==val.i_obj);
                //     this.rightChoose.splice(i,1)
                // }
                this.$forceUpdate()

            },
            handleNodeClick(val){
                // console.log(val,'treeData')
                // this.$emit('showData',val)


            },
            checktree(node,list){
                // console.log(this.datatype,list.checkedKeys.length,'0000',node)
                /*if(this.datatype==15&&list.checkedKeys.length>1){
                    console.log(111)
                    this.$refs.tree.setCheckedNodes([node]);
                }*/
            },
            handleCheckChange(val,check){
                // let obj=val
                // obj.flag=0
                // obj.i_pid=this.pid
                // obj.i_obj=val.i_obj
                // obj.i_type=this.datatype
                //多选

                //console.log(check,'i')
                if(check){
                    if (this.datatype==15){
                        //单选
                        this.$refs.tree.setCheckedNodes([val]);
                    }
                    this.leftChoose.push(val)
                }else {
                    let i=this.leftChoose.findIndex(one=>one.i_obj==val.i_obj)
                    this.leftChoose.splice(i,1)
                }
                this.$forceUpdate()
            },


            loadNode(node, resolve) {
                //console.log(this.treeData,'treeData');
                //console.log(node,resolve);
                let _this=this;
                if (node.level === 0) {
                    let val={
                        i_obj:0,
                        i_level:1,
                        i_state:0,

                    }
                    setTimeout(() => {
                        _this.getProductTree_z(val,resolve);
                        /*if (this.datatype==3){
                            _this.getProductTree(val,resolve);
                        }else if (this.datatype==4){
                            _this.getCompanyTree(val,resolve);
                        }else if (this.datatype==6||this.datatype==15||this.datatype==32||this.datatype==33){
                            _this.getDeptTree(val,resolve);
                        }else if (this.datatype==28 ){
                            _this.getYwTypeList(val,resolve);
                        }*/

                    }, 100)
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.getProductTree_z(node.data,resolve);
                    /*if (this.datatype==3){
                        _this.getProductTree(node.data,resolve);
                    }else if (this.datatype==4){
                        _this.getCompanyTree(node.data,resolve);
                    }else if (this.datatype==6||this.datatype==15||this.datatype==32||this.datatype==33){
                        _this.getDeptTree(node.data,resolve);
                    }else if (this.datatype==28){
                        _this.getYwTypeList(node.data,resolve);
                    }*/
                }
            },

            /**********************************/
            changetype(e){
                //console.log(e,'e')
            },
            //管理产品
            async getProductTree_z({i_obj=0,i_state=0},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                };
                let res = await API.getProductTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                vc_pzname:one.vc_name,
                                i_pzid:one.i_id.split('_')[0],
                                label:one.vc_name,
                                //label:one.vc_name+one.i_id,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,
                                disabled:one.haschild!=0,
                                i_pid:one.i_pid,
                                isLeaf: one.haschild==0,
                                i_type:this.i_type,
                            };
                            list.push(hash);
                        })
                    }
                    if(resolve){
                        return resolve(list);
                    }else{
                        this.treeData=list;
                    }

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //搜索产品
            async selectDictPz({i_obj=0,i_state=0},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                    vc_name:this.vc_search,
                };
                let res = await API.selectDictPz(param);
                if (res.code == 1) {
                    //console.log(res);
                    this.treeData=[];
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                vc_pzname:one.vc_name,
                                i_pzid:one.i_id.split('_')[0],
                                //label:one.vc_name,
                                label:one.vc_name+' '+one.i_id,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,
                                disabled:one.haschild!=0,
                                i_pid:one.i_pid,
                                isLeaf: one.haschild==0,
                                i_type:this.i_type,
                            };
                            list.push(hash);
                        })
                    }
                    this.treeData=list;
                    //return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            /**********************************/

            async getDeptTree({i_obj=0,i_state=0},resolve){

                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                };
                let res = await API.getDeptTree(param);
                if (res.code == 1) {


                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                //label:one.vc_name+one.i_id,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,
                                // i_pid:one.i_pid,
                                isLeaf: one.haschild==0,
                                disabled:(this.datatype==15||this.datatype==32||this.datatype==33)&&one.haschild==1,
                            };
                            list.push(hash);
                        })
                    }
                    // console.log(list,'tree')
                    // if (pid!=0){
                    return resolve(list);
                    // }else {
                    //     this.treeData=list
                    // }

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getCompanyTree({i_obj=0,i_state=0},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                };
                let res = await API.getCompanyTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                //label:one.vc_name+one.i_id,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,
                                // i_pid:one.i_pid,
                                isLeaf: one.haschild==0,
                            };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getProductTree({i_obj=0,i_state=0},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                };
                let res = await API.getProductTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                //label:one.vc_name+one.i_id,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,
                                // i_pid:one.i_pid,
                                isLeaf: one.haschild==0,
                            };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getYwTypeList({i_obj=0,i_state=0},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                };
                let res = await API.getYwTypeList(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                //label:one.vc_name+one.i_id,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,
                                // i_pid:one.i_pid,
                                isLeaf: one.haschild==0,

                            };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .alc{
        align-items: center;
    }
    .marl5{
        margin-left: 14px;
    }
    .flex{
        display: flex;
    }
    .marL5{
        margin-left: 5px;
    }
    .marB10{
        margin-bottom: 10px;
    }
    .bor{
        border: 1px solid #ebeef5;
        padding: 8px 10px;
        border-radius: 5px;
    }
</style>